import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

FormErrors.propTypes = {
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    critical: PropTypes.bool,
    shake: PropTypes.bool,
    errorStyle: PropTypes.object,
};

export default function FormErrors({ error, critical = true, shake, errorStyle }) {
    if (!error) return null;

    const errors = Array.isArray(error) ? error : [error];

    return (
        <ul
            className={classNames(styles.root, {
                [styles.nonCritical]: !critical,
                [styles.shake]: shake,
                [styles.animated]: shake,
            })}
            style={errorStyle}
        >
            {errors.map((msg, index) => (
                <li key={index}>{msg}</li>
            ))}
        </ul>
    );
}
